import { UtilsTypes } from '@tencent/wphk-act-base-types';
import { CouponType } from '@tencent/wphk-act-base-ui';

/** 券场景配置 */
// enum CouponSense = {
// lock

// }


/** 券状态 */
export enum CouponState {
  /** 未领取 */
  notReceived = '0',
  /** 已领取 */
  received = '1',
  /** 已使用 */
  used = '2',
  /** 已过期 */
  expired = '3',
}

/** 券兑换状态 */
export enum ExchangeState {
  /** 未开始 */
  notStarted = 1,
  /** 可兑换，展示库存 */
  avaliable,
  /** 奖品维度-日限额 今日已领完 */
  dayLimit,
  /** 奖品维度-总限额 券已售罄 */
  totalLimit,
  /** 用户维度-总限额 */
  totalUserLmit,
  /** 用户维度-月限额 */
  monthUserLimit,
  /** 印花不足 */
  qualNoEnough,
}

/** 券使用状态 */
export enum TransState {
  /** 1-初始，未使用 */
  NOT_USED = 1,
  /** 2-已使用 */
  USED = 2,
  /** 3-过期作废 */
  NOT_USED_EXPIRED = 3,
  /** 4-已退款（部分退款）*/
  REFUND = 4,
}

/** 券过期状态 */
export enum ExpireState {
  /** 未过期 */
  NOT_EXPIRED = 0,
  /** 已过期 */
  EXPIRED = 1,
}

interface IMerchantInfo {
  // 商户名
  mrchName?: string;
  // 商户logo
  mrchLogo?: string;
}

/** 券批次信息 */
export interface ICouponBatchInfo {
  /** 券批次id */
  couponId?: string;
  /* 是否商户展示券 */
  isSpCoupon?: boolean;
  /** 一次派发的券数量 */
  // perCount?: number;
  /** 过期天数 */
  // expireDay?: number;
  /* 是否券包（有层叠样式+金额下方“总值”） */
  isPkgCoupon?: boolean;
  /** 券包中的券数量, 一次派发的券数量(也就是perCount) ，V2新增 */
  pkgCount?: number;
  /** 是否连锁券（有层叠样式） */
  isChainCoupon?: boolean;
}

/** 金额券基本UI */
export interface ICashCouponUI {
  /* 券语言 */
  lang?: 'zh-hk' | 'zh-cn' | 'en';
  /* 是否展示「去使用」按钮 */
  isShowUseBtn?: boolean;
  /** 券名称 */
  couponName: string;
  /** 券描述 */
  couponDesc: string;
  /** 金额-已进行fen2Yuan;折扣-传20代表2折,80%off */
  discount: number;
  /** 是否展示右侧按钮 */
  isShowButton?: boolean;
  /* 按钮文案 */
  couponBtnText?: string;

  /** 当日限額文案 */
  dayLimitText?: string;
  /** 售罄文案，传入则替代默认文案 */
  totalLimitText?: string;
  /** 用户总领取上限文案 */
  totalUserLimitText?: string;
  /** 用户总月领取上限文案 */
  monthUserLimitTex?: string;

  /** 券面类型：展示金额/折扣 */
  couponType?: CouponType;

  /** 库存百分比 */
  availablePercent?: string;
  /** 剩余库存文案 */
  availablePercentText?: string;

  /** 货物图片，竖版券需要配置 */
  goodsUrl?: string;

  /** 货币类型 */
  currencyType?: UtilsTypes.CurrencyType;
}

/** 现金优惠券用户信息 */
export interface ICashCouponInfo extends ICouponBatchInfo, ICashCouponUI, IMerchantInfo {
  /** 券状态（枚举: 未领取/已领取未使用/已使用/已过期）*/
  couponState?: CouponState;
  /** 用户券id */
  userCouponid?: string;
  /** 兑换状态，枚举: 未开始、可兑换、今日已领完、本周期已领完、券已售罄 */
  exchangeState?: ExchangeState;
  // transState?: string | number;
  // expiredFlag?: string | number;

  /** 过期时间 */
  // expireTime?: string;
}
